import { useTranslation } from "react-i18next"
import { Link } from 'react-router-dom'
import Version from '../../version'

export function ResetPasswordSuccess() {
    const { t } = useTranslation()

    return (
        <div className='login-page'>
            <div className='login-card-wrapper'>
                <div className='login-card'>
                    <div className='login-card-body text-center'>
                        <h3 className='fw-bold mb-3' style={{ color: '#22c55e' }}>{t('forgot.restoresuccess')}</h3>
                        <Link to='/' className='btn btn-primary rounded-3'>{t('passwordreset.cancel')}</Link>
                    </div>
                </div>
                <div className='text-center' style={{ marginTop: '20px' }}><Version /></div>
            </div>
        </div>
    )
}
